module.exports = __webpack_public_path__ + "img/emoji_94.20850e6e.png";